export function buscaItemSessao() {

    const empresa = sessionStorage.getItem("empresa");
    return { empresa};
  }